export default "__VITE_ASSET__R7wbcl6V__"